/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect} from "react";

import { isTokenPresent } from "../utils/auth";
import useSpecialToken from "../utils/hooks/useSpecialToken";

import logo from "../assets/img/logoSI.webp"

import TabsNav from "../components/TabsNav";
import Menu from "../components/Menu"
import "../style/css/mainconfig.css"
import Header from "../components/Header";

function MainConfig() {
   
  const { userName, specialToken } = useSpecialToken();

  useEffect(() => {
    if (!isTokenPresent()) {
      window.location.href = '/';
    }
  }); 

    return (
    
      <div className="maincf" >
 
        <div className="maincf__box1">
     
          <Header userName={userName}/>
        
          <div className="maincf__box1__container">

            <h2 className="maincf__box1__container__title"> Configuration Globale</h2>

            <TabsNav 
            tab1="Etablissement" 
            tab2="Email" 
            path1="/configuration/globale" 
            path2="/"/>

            <div className="maincf__box1__container__etablissement">

              <div className="maincf__box1__container__etablissement__item">

                <h3 className="maincf__box1__container__etablissement__item__h3"> Nom :</h3>

                <p className="maincf__box1__container__etablissement__item__name"> SI-Plus </p>
              
              </div>

              <div className="maincf__box1__container__etablissement__item">

                <h3 className="maincf__box1__container__etablissement__item__h3"> Raison Sociale : </h3>

                <p className="maincf__box1__container__etablissement__item__name"> SI-Plus Avignon </p>
                
              </div>

              <div className="maincf__box1__container__etablissement__item">

                <h3 className="maincf__box1__container__etablissement__item__h3"> Responsable : </h3>
                
                <p className="maincf__box1__container__etablissement__item__name"> David Falgiglio</p>

              </div>

              <div className="maincf__box1__container__etablissement__item">

                <h3 className="maincf__box1__container__etablissement__item__h3"> Site internet : </h3>

                <a href="https://www.si-plus.fr/ " id="a_config" className="maincf__box1__container__etablissement__item__name"> Visiter le site</a>
              
              </div>

              <div className="maincf__box1__container__etablissement__item">

                <h3 className="maincf__box1__container__etablissement__item__h3"> Email : </h3>
                
                <p className="maincf__box1__container__etablissement__item__name"> contact@si-plus.fr </p>
                
              </div>

              <div className="maincf__box1__container__etablissement__item">

                <h3 className="maincf__box1__container__etablissement__item__h3"> Logo : </h3>

                <img src={logo} alt="logo siplus"/>

              </div>

              <div className="maincf__box1__container__etablissement__item">

                <h3 className="maincf__box1__container__etablissement__item__h3"> Téléphone : </h3>

                <p className="maincf__box1__container__etablissement__item__name" > 04.94.05.31.88 </p>
                
              </div>

            </div>

          </div>

        </div>

        <div className="maincf__menu">

          <Menu/>
        
        </div>

      </div>
      
    );
  }
  
export default MainConfig;